// extracted by mini-css-extract-plugin
export var cards = "cards-module--cards--3vm6z";
export var right = "cards-module--right--2wGtl";
export var up = "cards-module--up--1Wu4v";
export var center = "cards-module--center--2ZTYc";
export var down = "cards-module--down--2Le7J";
export var left = "cards-module--left--29bqQ";